export const RAMUS2_READ_ONLY_MESSAGE =
  'Ramus 2.0 data is read-only and only available in detail view';

const RAMUS2_PREFIX = 'ramus2-';
const NUMERIC_ID_REGEX = /^\d+$/;
const NUMERIC_DEVICE_ID_REGEX = /^\d+(-\d+)?$/;

export function isRamus2CompanyId(id?: string | null) {
  return !!id && NUMERIC_ID_REGEX.test(id);
}

export function isRamus2GroupId(id?: string | null) {
  return !!id && NUMERIC_ID_REGEX.test(id);
}

export function isRamus2AssetId(id?: string | null) {
  return !!id && NUMERIC_ID_REGEX.test(id);
}

export function isRamus2DeviceId(id?: string | null) {
  return !!id && NUMERIC_DEVICE_ID_REGEX.test(id);
}

export function getEntityDetailPath(
  entity: 'company' | 'group' | 'asset' | 'device',
  id?: string | null,
) {
  return id ? `/${entity}/${id}` : `/${entity}`;
}
